/**
 * Shelves (and the slots inside them) sorted by their number. The planogram uploaded by a cabinet can list
 * shelves out of order (e.g. 1,2,3,4,6,5); the planogram grid draws rows in array order, so without sorting the
 * row a refiller taps as the 5th shelf would be labelled and calibrated as shelf 6. Does not mutate the input.
 */
export const sortShelvesByNumber = shelves => {
  if (!Array.isArray(shelves)) return [];
  const byNumber = key => (a, b) => Number(a[key]) - Number(b[key]);
  return [...shelves]
    .sort(byNumber('shelf'))
    .map(shelf =>
      Array.isArray(shelf.slots)
        ? { ...shelf, slots: [...shelf.slots].sort(byNumber('slot')) }
        : shelf
    );
};

// planogram shelf types drawn as scale shelves: scale1 = smartshelf reader, scale2 = device-weight-service lanes
export const SCALE_SHELF_TYPES = ['scale1', 'scale2'];
export const isScaleShelfType = type => SCALE_SHELF_TYPES.includes(type);

/**
 * Number of inventory snapshot items sitting on a shelf/slot, or null when no snapshot is loaded yet.
 * Scale items in the snapshot carry shelf, slot and barcode; RFID items have no shelf/slot and are ignored.
 */
export const countItemsAtSlot = (items, shelf, slot) => {
  if (!Array.isArray(items)) return null;
  return items.filter(
    i =>
      i &&
      i.barcode &&
      Number(i.shelf) === Number(shelf) &&
      Number(i.slot) === Number(slot)
  ).length;
};

export const cabinetShelfConfig = {
  'hybrid-4-shelfs': {
    shelfConfig: [
      {
        shelf: 1,
        type: 'scale1',
        identifiedSensorShelf: 1,
        slots: [
          {
            slot: 1,
            sensorSlot: 11,
          },
          {
            slot: 2,
            sensorSlot: 12,
          },
          {
            slot: 3,
            sensorSlot: 13,
          },
        ],
      },
      {
        shelf: 2,
        type: 'scale1',
        identifiedSensorShelf: 1,
        slots: [
          {
            slot: 1,
            sensorSlot: 14,
          },
          {
            slot: 2,
            sensorSlot: 15,
          },
          {
            slot: 3,
            sensorSlot: 16,
          },
        ],
      },
      {
        shelf: 3,
        type: 'rfid',
      },
      {
        shelf: 4,
        type: 'rfid',
      },
    ],
  },
  'lab-4-scale-shelve': {
    shelfConfig: [
      {
        shelf: 1,
        type: 'scale1',
        identifiedSensorShelf: 1,
        slots: [
          {
            slot: 1,
            sensorSlot: 11,
          },
          {
            slot: 2,
            sensorSlot: 13,
          },
          {
            slot: 3,
            sensorSlot: 14,
          },
          {
            slot: 4,
            sensorSlot: 16,
          },
        ],
      },
      {
        shelf: 2,
        type: 'scale1',
        identifiedSensorShelf: 2,
        slots: [
          {
            slot: 1,
            sensorSlot: 21,
          },
          {
            slot: 2,
            sensorSlot: 24,
          },
          {
            slot: 3,
            sensorSlot: 26,
          },
        ],
      },
      {
        shelf: 3,
        type: 'scale1',
        identifiedSensorShelf: 3,
        slots: [
          {
            slot: 1,
            sensorSlot: 31,
          },
          {
            slot: 2,
            sensorSlot: 36,
          },
        ],
      },
      {
        shelf: 4,
        type: 'rfid',
      },
    ],
  },
};
